import { guidsAreEqual } from "features/../../../shared/modules/helpers";

const normalizeId = (id) => (id == null ? id : `${id}`.toLowerCase());

export const removeNotApplicableReturnOnInvestments = (
  newSheetData,
  returnOnInvestmentData,
) => {
  if (!newSheetData.returnOnInvestments?.length) return;

  const sheetUnitIds = (newSheetData.systemScheduleItems || [])
    .map((item) => item?.unit?.value)
    .filter(Boolean)
    .map(normalizeId);

  newSheetData.returnOnInvestments = newSheetData.returnOnInvestments.filter(
    (sheetRoi) => {
      const roiData = (returnOnInvestmentData || []).find((r) =>
        guidsAreEqual(r.id, sheetRoi.returnOnInvestmentId),
      );

      if (!roiData) return true;

      const requiredIds = roiData.meteredServiceIds || [];
      if (!requiredIds.length) return true;

      return requiredIds.every((meteredServiceId) =>
        sheetUnitIds.includes(normalizeId(meteredServiceId)),
      );
    },
  );
};
